import { render, staticRenderFns } from "./SettingsUploadOptions.vue?vue&type=template&id=c940c786&scoped=true&"
import script from "./SettingsUploadOptions.vue?vue&type=script&lang=js&"
export * from "./SettingsUploadOptions.vue?vue&type=script&lang=js&"
import style0 from "./SettingsUploadOptions.vue?vue&type=style&index=0&id=c940c786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c940c786",
  null
  
)

export default component.exports